class Utils {
  static isRetina = (first, second) => {
    if (window.devicePixelRatio >= 2) {
      return second;
    }
    return first;
  }
}

export default Utils;